<!-- Upload Pix Detail Record -->

<template>

	<div class="upload-pix-detail">
		<div class="left-frame">
			<div :class="(idx==0)? 'chk-box': 'chk-box active-blue'" @click="clickMove(-1)">
				<UniIcon 
					ico="arrow" 
					color="#FFF" 
					fit="1"
					pad="2"				
				/>
			</div>

			<div />

			<div :class="(idx<upload.pix.length-1)? 'chk-box bottom rot-180 active-blue': 'chk-box bottom rot-180'" @click="clickMove(1)">
				<UniIcon 
					ico="arrow" 
					color="#FFF" 
					fit="1"
					pad="2"				
				/>
			</div>

		</div>

		<div class="pic-frame">
			<img class="center_me" :src="rec.imgs.mid" />
		</div>

		<div class="check-frame">

			<div class="chk-box active-blue" @click="clickRotate">
				<UniIcon 
					ico="rotate90" 
					color="#FFF" 
					fit="1"
					pad="2"				
				/>
			</div>

			<div class="v-spacer" />

			<div :class="rec.primary? 'chk-box active-blue': 'chk-box'" @click="clickCheckFlag('primary')">
				<UniIcon 
					ico="star" 
					color="#FFF" 
					fit="1"
					pad="3"				
				/>
			</div>

			<div class="h-spacer"></div>

			<div class="chk-box little-round" @click="clickHelp">
				<UniIcon 
					ico="question" 
					color="#FFF" 
					fit="1"
					pad="3"
				/>
			</div>

<!-- 

			<div class="v-spacer" />

			<div class="chk-box" @click="clickTest">
				<UniIcon 
					ico="test" 
					color="#000" 
					fit="1"
				/>
			</div>

			<div class="test-box">{{rec.testObj.updTime}}</div> 
-->

		</div>

		<div class="right-frame">
			<div class="chk-box transparent right" @click="clickDel">
				<UniIcon 
					ico="cancel" 
					color="#C30" 
					fit="1"
					pad="0"				
				/>
			</div>
		</div>

	</div>

</template>

<script>
import { m } from "@/utils/utils"
import { mapState } from 'vuex';
import { eventBus } from "@/main";
import * as Utils from "@/utils/utils"

export default {
	props: {
		rec: {},
		idx: Number,
	},
	computed: {
		...mapState('app', ['upload']),
	},
	methods: {
		clickTest() {
			Utils.blur();
			m("detail click test");
			let payload = {
				rec: this.rec,
			}
			this.$store.dispatch('app/goTest', payload);
		},
		clickDel() {
			Utils.blur();
			const data = {
				step: "upload",
				idx: this.idx,
			};
			this.$store.dispatch('app/delPic', data);
		},
		clickHelp() {
			Utils.blur();
			let data = {
				popType: "win",
				popTitle: "Help: Primary Image",
				compName: "HelpMainImg",
			};
			eventBus.$emit("popup", data);			
		},
		clickRotate() {
			Utils.blur();
			const data = {
				step: "upload",
				idx: this.idx,
			};
			this.$store.dispatch('app/rotatePic', data);
		},
		clickMove(amount) {
			Utils.blur();
			const data = {
				step: "upload",
				idx: this.idx,
				amount: amount,
			};
			this.$store.dispatch('app/movePic', data);
		},
		clickCheckFlag(flagName) {
			Utils.blur();
			const data = {
				step: "upload",
				idx: this.idx,
				flagName: flagName,	
			};
			this.$store.dispatch('app/clickCheckFlag', data);
		},
	},
	mounted() {
		m("detail mounted", this.rec);
	},
	updated() {
		m("detail updated =====");
	},
}
</script>

<style scoped>

.upload-pix-detail {
	width: 320px;
	height: 120px;
	overflow: hidden;
	white-space: nowrap;
	padding: 5px;
	white-space: nowrap;
	background-color: #FFFFE6;
	border-radius: 8px;
	border: solid 2px #CB9;
}

.left-frame {
	position: relative; 
	display: inline-block;
	width: 35px;
	height: 100%;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #69C;
}

.pic-frame {
	display: inline-block;
	width: 144px;
	height: 108px;
	overflow: hidden;
	vertical-align: top;
	background-color: #FFF;
	border-radius: 8px;
	border: solid 1px #999;
}

.check-frame {
	display: inline-block;
	width: 80px;
	height: 100%;
	/* overflow: hidden; */
	vertical-align: top;
	padding: 0px 0px 0px 5px;
	border: solid 0px #C30;
}

.right-frame {
	float:right;
	width: 40px;
	height: 100%;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #090;
}


.lab-box {
	display: inline-block;
	width: 60px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	padding: 5px 5px 0px 10px;
	border: solid 0px #369;
}

.test-box {
	display: inline-block;
	width: 90px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	padding: 5px 5px 0px 10px;
	border: solid 0px #090;
}

.chk-box {
	display: inline-block;
	width: 30px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	cursor: pointer;
	background-color: #EEE;
	border-radius: 4px;
	border: solid 1px #999;
}

.little-round {
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background-color: #369;
	border: solid 0px #F00;
}

.bottom {
	position: absolute; 
	bottom: 0px; 
}

.active {
	background-color: #393;
}

.active-blue {
	background-color: #369;
}

.transparent {
	background-color: transparent;
	border: solid 0px #999;
}

.rot-180 {
	transform: rotate(180deg);
}

.right {
	float: right;
}

.v-spacer {
	width: 10px;
	height: 5px;
	border: solid 0px #999;
}

.h-spacer {
	display: inline-block;
	width: 10px;
	height: 5px;
	vertical-align: top;
	border: solid 0px #999;
}

.center_me {
	display:inline-block;
	max-width: 100%;
	max-height: 100%;
	position: relative;
	top: 50%;
	left: 50%;
	-webkit-transform: translateX(-50%) translateY(-50%);
	-moz-transform: translateX(-50%) translateY(-50%);
	-ms-transform: translateX(-50%) translateY(-50%);
	-o-transform: translateX(-50%) translateY(-50%);
	transform: translateX(-50%) translateY(-50%);
	border: solid 0px #C30;
}

</style>
